//
//
//
//
//
//
//
//
//
//
//
//


import FilesGroup from '../../components/File/FilesGroup.js'
import FilesField from '../../components/File/FilesField.vue'

export default {
  components: {
    FilesField
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const self = this
    return {
      filesGroup: new FilesGroup({
        categoryKey: 'orderAdmittanceReception',
        readonly: !this.isMobile,
        enrichmentFn (document) {
          return {
            name: self.orderAdmittance.name + '-' + this.files.length + '.' + document.contentType.split('/')[1] // TODO FileDocument - name
          }
        },
        sourceConfig: {
          get objectId () {
            return self.orderAdmittance.id
          },
          uploadURL: '/service/delta/document/upload',
          removeURL: '/service/delta/document/deleteFromObject'
        }
      })
    }
  },
  watch: {
    orderAdmittance: function () {
      this.filesGroup.clear()

      if (this.orderAdmittance.file) {
        this.orderAdmittance.file.forEach(document => {
          this.filesGroup.pushFile(document)
        })
      }
    }
  },
  methods: {
    onRemoveFile: function ({ file: fileWrapper, filesGroup }) {
      filesGroup.removeFile(fileWrapper).then(() => {
        this.$emit('update')
      })
    },
    uploadFiles: async function () {
      try {
        return await this.filesGroup.uploadFiles({
          notify: true,
          target: this
        })
      } catch (error) {
        throw new Error(error.message)
      }
    },
    onFileAddToUpload: function (fileWrapper) {
      this.uploadFiles()
        .then(result => {
          this.$emit('update')
        }).catch(result => {
          if (result.message) {
            this.$q.notify({
              type: 'negative',
              message: result.message,
              progress: true,
              timeout: 8000
            })
          }
        })
    }
  }
}

